import * as types from './_actionTypes';

export const fetchCollegeDashboardRequest = () => ({
  type: types.FETCH_COLLEGE_DASHBOARD_REQUEST
});

export const fetchCollegeDashboardSuccess = (data) => ({
  type: types.FETCH_COLLEGE_DASHBOARD_SUCCESS,
  payload: data
});

export const fetchCollegeDashboardFailure = (error) => ({
  type: types.FETCH_COLLEGE_DASHBOARD_FAILURE,
  payload: error
});

export const fetchCollegeAnalyticsRequest = () => ({
  type: types.FETCH_COLLEGE_ANALYTICS_REQUEST
});

export const fetchCollegeAnalyticsSuccess = (analytics) => ({
  type: types.FETCH_COLLEGE_ANALYTICS_SUCCESS,
  payload: analytics
});

export const fetchCollegeAnalyticsFailure = (error) => ({
  type: types.FETCH_COLLEGE_ANALYTICS_FAILURE,
  payload: error
});